import React, { useState } from "react";
import { ADMIN_ROLE } from "../utils/constants";

const useAuth = () => {
  const [token, setToken] = useState(localStorage.getItem("accessToken") || "");
  const handleSetToken = (value) => {
    setToken(value);
    localStorage.setItem("accessToken", value);
  };
  const handleRemoveToken = () => {
    localStorage.clear();
  };
  const decodeJWT = (token) => {
    const [header, payload, signature] = token.split(".");
    const decodedPayload = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
    );
    return decodedPayload;
  };
  const isAdmin = () => {
    const roles = decodeJWT(token)?.roles;
    if (Array.isArray(roles)) {
      return roles.includes(ADMIN_ROLE);
    } else if (typeof roles === "string") {
      return roles === ADMIN_ROLE;
    }
    return false;
  };

  return { token, handleSetToken, handleRemoveToken, isAdmin };
};

export default useAuth;
